module.exports = __webpack_public_path__ + "static/media/22-8.74ef9d8a.mp3";